module.exports = __webpack_public_path__ + "static/media/collage3_1366.59bd218a.png";